const EconomyExpresss = () => {
    return (
      <div>
      
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Economy Express
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS Economy Express is a standard second-day delivery service, with over 80% shipments being delivered 
              within half the promised time. Although offered in TCS branded boxes of 5, 10, 15, 20 and 25 kilograms, 
              this service can be used for any weight up to 999 kg. Any shipment over 30 kg is delivered in customer-provided 
              packing. However, the Time Choice option is not available in combination with this service.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/DomesticScrollingBanner/imag6.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default EconomyExpresss;